import { Alert, Typography } from '@mui/material';
import type { ParentChildAgeCheck } from '@utils/parentalConsent';

interface ParentChildAgeAlertProps {
  check: ParentChildAgeCheck;
}

const ParentChildAgeAlert = ({ check }: ParentChildAgeAlertProps) => {
  if (check.level === 'ok' && !check.title) return null;
  const severity = check.level === 'red' ? 'error' : 'warning';
  return (
    <Alert severity={severity} sx={{ mt: 2, mb: 1 }}>
      {check.title && (
        <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.5 }}>
          {check.title}
        </Typography>
      )}
      {check.message && (
        <Typography variant="body2" sx={{ mb: 1 }}>
          {check.message}
        </Typography>
      )}
      <Typography variant="body2">
        {check.legalNotice}
      </Typography>
    </Alert>
  );
};

export default ParentChildAgeAlert;
